<template>
  <div>
    <p>
      Mit der Nutzung der schmuckli.dev Applikationen gelten folgende
      Bestimmungen:
    </p>
    <h3>Servicevertrag Dienste</h3>
    <p>
      schmuckli.dev behält sich das Recht vor, Dienste und Services wie die
      Speicherung der Daten in der Cloud oder Synchronisationsdienste 
      zu verändern, einzustellen und zu löschen.
    </p>
    <h3>Servicevertrag Applikationen</h3>
    <p>
      schmuckli.dev behält sich das Recht vor, den Support für alle Applikationen
      (basierend auf Web, Android und iOS) einzustellen.
    </p>
    <h3>Käufe und Transaktionen</h3>
    <p>
      Beim Kauf von Applikationen oder Dienstleistungen über den Apple App Store
      sowie über den Google Play Store gelten die Bestimmungen der jeweiligen
      Händler.
    </p>
    <h3>Firebase</h3>
    <p>
      Bei einer Kleinzahl an Apps wird als primäres Backend Firebase verwendet.
      Daher gelten auch sämtliche Nutzungsbedingungen von firebase.com und
      google.com.
    </p>
    <h3>Google Assistant</h3>
    <p>
      Die Nutzung des Google Assistants erfolgt auf freiwilliger Basis des
      Nutzers. Während den Konversationen werden Appdaten, wie zu Beispiel Name
      von Listen und deren Inhalt an Google gesendet. Mit der Verlinkung zu
      Google unter den "Einstellungen" werden automatisch die Konten verknüpft.
      Der Google Assistant wird sich dann per E-Mail Adresse mit Ihrem Konto
      verbinden.
    </p>
  </div>
</template>
<script>
export default {
  name: "TermsGerman",
};
</script>
